import {AppEntities} from "../../../config/entities";
import {NFLookupCatalog} from "./NFLookupCatalog";
import React from "react";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";

interface IProps {
    fieldName: string;
    title?: string;
    required?: boolean;
    showBorder?: boolean;
    width?: number;
    selectedCatalog?: boolean;
    setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupAccount = ({
                                    fieldName,
                                    required,
                                    showBorder,
                                    title,
                                    width,
                                    selectedCatalog,
                                    setSelectedCatalog,
                                }: IProps) => {
    const loadData = async (searchText: string | undefined) => {
        return await AppEntities.Account.getDataService().GetAll(searchText);
    };

    return (
        <>
            <NFLookupCatalog
                fieldName={fieldName}
                title={title}
                entity={AppEntities.Account}
                width={width}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                displayFieldName={"accountNo"}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
            >
                {/*<NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>*/}
                <NFLookupCatalogColumn fieldName={"accountNo"} caption={"Account No"}/>
                <NFLookupCatalogColumn fieldName={"name"} caption={"Name"}/>
            </NFLookupCatalog>
        </>
    );
};
